import moment from 'moment-mini';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

type Dateish = Date | string;

function toDate(dateish: Dateish): Date {
  if (typeof dateish === 'string') {
    return new Date(dateish);
  } else {
    return dateish;
  }
}

export function floorDate(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

export function ceilDate(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 99);
}

export function diffDate(a: Dateish, b: Dateish): number {
  return toDate(a).getTime() - toDate(b).getTime();
}

export function addDate(dateish: Dateish, delta: number): Date {
  if (!delta && delta !== 0) {
    console.error('Trying to add a non-number to a date!', dateish, delta);
  }
  return new Date(toDate(dateish).getTime() + delta);
}

// returns the number of milliseconds in the inputted number of days
export function fromDays(n: number): number {
  if (!n && n !== 0) {
    console.error('Trying to determine milliseconds from days but did not provide number of days', n);
  }
  return n * MS_PER_DAY;
}

// returns the number of days in the inputted number of milliseconds
export function days(n: number): number {
  return Math.floor(n / MS_PER_DAY);
}

export function removeTimeDate(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function equalDate(a: Date, b: Date): boolean {
  return a.getTime() === b.getTime();
}

export function moveToDate(src: Date, target: Date): Date {
  const d = new Date(target);
  d.setMonth(src.getMonth());
  d.setDate(src.getDate());
  return d;
}

export function startOf(value: 'day' | 'week' | 'month' | 'year') {
  return moment().startOf(value).toDate();
}
